import { docsHttpService, maxInvoiceThreadExportCount, ThreadFiltersInput } from "@megaron/docs-contracts";
import { InvoiceThreadDoc } from "@megaron/invoices-contracts";
import { HttpServiceClient } from "@megaron/http-service-client";
import { Failure, Ok } from "@megaron/result";

const exportPageSize = 500;

type DocsClient = HttpServiceClient<typeof docsHttpService>;

export type CsvExportResult = {
  items: InvoiceThreadDoc[];
  totalCount: number | undefined;
  wasTruncated: boolean;
};

export const fetchAllThreadsForCsv = async (
  docs: DocsClient,
  input: ThreadFiltersInput,
  onProgress?: (loadedCount: number, totalCount?: number) => void,
): Promise<Ok<CsvExportResult> | Failure<string>> => {
  const threads: InvoiceThreadDoc[] = [];
  let cursor: string | undefined;
  let totalCount: number | undefined;

  do {
    const response = await docs.exportInvoiceThreads({
      ...input,
      limit: exportPageSize,
      cursor,
    });

    if (response.isFailure) {
      return Failure("Nie udało się pobrać faktur do eksportu CSV");
    }

    threads.push(...response.value.items);
    totalCount = response.value.count;
    cursor = response.value.cursor;

    if (threads.length > maxInvoiceThreadExportCount) {
      threads.length = maxInvoiceThreadExportCount;
    }

    onProgress?.(threads.length, Math.min(totalCount ?? threads.length, maxInvoiceThreadExportCount));

    if (threads.length >= maxInvoiceThreadExportCount) {
      break;
    }
  } while (cursor);

  const wasTruncated =
    totalCount !== undefined && totalCount > maxInvoiceThreadExportCount && threads.length >= maxInvoiceThreadExportCount;

  return Ok({ items: threads, totalCount, wasTruncated });
};
